import { render } from "./DetailPoFulfillment.vue?vue&type=template&id=21a03f42&scoped=true"
import script from "./DetailPoFulfillment.vue?vue&type=script&lang=js"
export * from "./DetailPoFulfillment.vue?vue&type=script&lang=js"

import "./DetailPoFulfillment.vue?vue&type=style&index=0&id=21a03f42&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21a03f42"]])

export default __exports__